'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Field = require('../Field/Field');

var _Field2 = _interopRequireDefault(_Field);

var _Label = require('../Label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Thumb = require('./Thumb');

var _Thumb2 = _interopRequireDefault(_Thumb);

var _Track = require('./Track');

var _Track2 = _interopRequireDefault(_Track);

var _Label3 = require('./Label');

var _Label4 = _interopRequireDefault(_Label3);

var _utils = require('../../utils');

var _keyCodes = require('../../utils/keyCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/sort-comp */


var Slider = function (_React$Component) {
    _inherits(Slider, _React$Component);

    function Slider() {
        _classCallCheck(this, Slider);

        // customValues overrides
        var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));

        _this.readDefaultValue = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            return props.customValues && props.defaultValue ? _this.getCustomValueDefaults(props) : props.defaultValue;
        };
        _this.readMinValue = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            return props.customValues ? 0 : props.minValue;
        };
        _this.readMaxValue = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            return props.customValues ? props.customValues.length - 1 : props.maxValue;
        };
        _this.readStep = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            return props.customValues ? 1 : props.step || 1;
        };
        _this.readValue = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            return props.customValues && props.value ? _this.getValueFromCustomValues(props.value, props.customValues) : props.value;
        };
        _this.displayCustomValue = function (value) {
            var customValues = _this.props.customValues;

            return customValues[value];
        };
        _this.state = {
            defaultValue: _this.readDefaultValue(),
            minValue: _this.readMinValue(),
            maxValue: _this.readMaxValue(),
            step: _this.readStep(),
            isDragged: false,
            value: _this.readValue() || _this.readDefaultValue() || _this.readMinValue() || 0
        };
        _this.id = _this.props.id || (0, _utils.idGen)('slider'); // eslint-disable-line react/destructuring-assignment
        _this.labelId = _this.id + '-label';
        _this.componentWillReceiveProps = function (nextProps) {
            _this.setState({
                defaultValue: _this.readDefaultValue(nextProps),
                minValue: _this.readMinValue(nextProps),
                maxValue: _this.readMaxValue(nextProps),
                step: _this.readStep(nextProps),
                value: _this.readValue(nextProps)
            });
        };
        /**
         * Return the thumb key closest to a point
         * @param {Point} position
         * @return {string}
         */
        _this.getKeyByPosition = function (position) {
            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var _this$state = _this.state,
                minValue = _this$state.minValue,
                maxValue = _this$state.maxValue;

            var positions = _this.getPositionsFromValues(values, minValue, maxValue, _this.getTrackClientRect());
            if (_this.isMultiValue()) {
                var distanceToMin = (0, _utils.distanceTo)(position, positions.min);
                var distanceToMax = (0, _utils.distanceTo)(position, positions.max);
                if (distanceToMin < distanceToMax) {
                    return 'min';
                }
            }
            return 'max';
        };
        /**
         * Return all the thumb keys
         * @return {string[]}
         */
        _this.getKeys = function () {
            if (_this.isMultiValue()) {
                return ['min', 'max'];
            }
            return ['max'];
        };
        _this.startDrag = function () {
            _this.setState({ isDragged: true }); // eslint-disable-line react/no-unused-state
        };
        _this.endDrag = function () {
            _this.setState({ isDragged: false }); // eslint-disable-line react/no-unused-state
        };
        _this.reset = function () {
            var value = _this.props.value;
            var minValue = _this.state.minValue;

            var values = _this.isMultiValue() ? value : {
                min: minValue,
                max: value
            };
            _this.updateValues(values);
        };
        /**
         * Return true if the difference between the new and the current value is
         * greater or equal to the step amount of the component
         * @param {Range} values
         * @return {boolean}
         */
        _this.hasStepDifference = function (values) {
            var currentValues = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var step = _this.state.step;

            return (0, _utils.length)(values.min, currentValues.min) >= step || (0, _utils.length)(values.max, currentValues.max) >= step;
        };
        /**
         * Return true if the component accepts a min and max value
         * @return {boolean}
         */
        _this.isMultiValue = function () {
            return (0, _utils.isObject)(_this.getValue());
        };
        /**
         * Return true if the range is within the max and min value of the component
         * @param {Range} values
         * @return {boolean}
         */
        _this.isWithinRange = function (values) {
            var _this$state2 = _this.state,
                minValue = _this$state2.minValue,
                maxValue = _this$state2.maxValue;

            if (_this.isMultiValue()) {
                return values.min >= minValue && values.max <= maxValue && values.min < values.max;
            }
            return values.max >= minValue && values.max <= maxValue;
        };
        /**
         * Return true if the new value should trigger a render
         * @param {Range} values
         * @return {boolean}
         */
        _this.shouldUpdate = function (values) {
            return _this.isWithinRange(values) && _this.hasStepDifference(values);
        };
        /**
         * Update the position of a thumb
         * @param {string} key
         * @param {Point} position
         */
        _this.updatePosition = function (key, position) {
            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var _this$state3 = _this.state,
                minValue = _this$state3.minValue,
                maxValue = _this$state3.maxValue;

            var positions = _this.getPositionsFromValues(values, minValue, maxValue, _this.getTrackClientRect());
            positions[key] = position;
            _this.updatePositions(positions);
        };
        /**
         * Update the positions of multiple thumbs
         * @param {Object} positions
         * @param {Point} positions.min
         * @param {Point} positions.max
         */
        _this.updatePositions = function (positions) {
            var _this$state4 = _this.state,
                minValue = _this$state4.minValue,
                maxValue = _this$state4.maxValue,
                step = _this$state4.step;

            var values = {
                min: _this.getValueFromPosition(positions.min, minValue, maxValue, _this.getTrackClientRect()),
                max: _this.getValueFromPosition(positions.max, minValue, maxValue, _this.getTrackClientRect())
            };
            var transformedValues = {
                min: _this.getStepValueFromValue(values.min, step),
                max: _this.getStepValueFromValue(values.max, step)
            };
            _this.updateValues(transformedValues);
        };
        /**
         * Update the value of a thumb
         * @param {string} key
         * @param {number} value
         */
        _this.updateValue = function (key, value) {
            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            values[key] = value;
            _this.updateValues(values);
        };
        /**
         * Update the values of multiple thumbs
         * @private
         * @param {Range|number} values
         */
        _this.updateValues = function (values) {
            var _this$props = _this.props,
                customValues = _this$props.customValues,
                onChange = _this$props.onChange;

            if (!_this.shouldUpdate(values)) {
                return;
            }
            var newValue = _this.isMultiValue() ? values : values.max;
            _this.setState({ value: newValue });
            if (onChange) {
                onChange(customValues ? _this.getCustomValue(newValue) : newValue);
            }
        };
        /**
         * Increment the value of a thumb by key name
         * @param {string} key
         */
        _this.incrementValue = function (key) {
            var step = _this.state.step;

            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var value = values[key] + step;
            _this.updateValue(key, value);
        };
        /**
         * Decrement the value of a thumb by key name
         * @param {string} key
         */
        _this.decrementValue = function (key) {
            var step = _this.state.step;

            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var value = values[key] - step;
            _this.updateValue(key, value);
        };
        /**
         * Listen to mouseup event
         */
        _this.addDocumentMouseUpListener = function () {
            _this.removeDocumentMouseUpListener();
            _this.node.ownerDocument.addEventListener('mouseup', _this.handleMouseUp);
        };
        /**
         * Listen to touchend event
         */
        _this.addDocumentTouchEndListener = function () {
            _this.removeDocumentTouchEndListener();
            _this.node.ownerDocument.addEventListener('touchend', _this.handleTouchEnd);
        };
        /**
         * Stop listening to mouseup event
         */
        _this.removeDocumentMouseUpListener = function () {
            _this.node.ownerDocument.removeEventListener('mouseup', _this.handleMouseUp);
        };
        /**
         * Stop listening to touchend event
         */
        _this.removeDocumentTouchEndListener = function () {
            _this.node.ownerDocument.removeEventListener('touchend', _this.handleTouchEnd);
        };
        /**
         * Handle any "mousemove" event received by the thumb
         * @param {SyntheticEvent} event
         * @param {string} key
         */
        _this.handleThumbDrag = function (event, key) {
            var disabled = _this.props.disabled;

            if (disabled) {
                return;
            }
            var position = _this.getPositionFromEvent(event, _this.getTrackClientRect());
            requestAnimationFrame(function () {
                return _this.updatePosition(key, position);
            });
        };
        /**
         * Handle any "keydown" event received by the thumb
         * @param {SyntheticEvent} event
         * @param {string} key
         */
        _this.handleThumbKeyDown = function (event, key) {
            var disabled = _this.props.disabled;

            if (disabled) {
                return;
            }
            switch (event.keyCode) {
                case _keyCodes.LEFT_ARROW:
                case _keyCodes.DOWN_ARROW:
                    event.preventDefault();
                    _this.decrementValue(key);
                    break;
                case _keyCodes.RIGHT_ARROW:
                case _keyCodes.UP_ARROW:
                    event.preventDefault();
                    _this.incrementValue(key);
                    break;
                default:
                    break;
            }
        };
        /**
         * Handle any "mousedown" event received by the track
         * @param {SyntheticEvent} event
         * @param {Point} position
         */
        _this.handleTrackMouseDown = function (event, position) {
            var disabled = _this.props.disabled;

            if (disabled) {
                return;
            }
            _this.updatePosition(_this.getKeyByPosition(position), position);
        };
        /**
         * Handle the start of any mouse/touch event
         */
        _this.handleInteractionStart = function () {
            var _this$props2 = _this.props,
                onChangeComplete = _this$props2.onChangeComplete,
                onChangeStart = _this$props2.onChangeStart,
                customValues = _this$props2.customValues;

            if (onChangeStart) {
                var newValue = _this.getValue();
                onChangeStart(customValues ? _this.getCustomValue(newValue) : newValue);
            }
            if (onChangeComplete && !(0, _utils.isDefined)(_this.startValue)) {
                _this.startValue = _this.getValue();
            }
        };
        /**
         * Handle the end of any mouse/touch event
         */
        _this.handleInteractionEnd = function () {
            var _this$props3 = _this.props,
                onChangeComplete = _this$props3.onChangeComplete,
                customValues = _this$props3.customValues;

            if (!onChangeComplete || !(0, _utils.isDefined)(_this.startValue)) {
                return;
            }
            if (_this.startValue !== _this.getValue()) {
                var newValue = _this.getValue();
                onChangeComplete(customValues ? _this.getCustomValue(newValue) : newValue);
            }
            _this.startValue = null;
        };
        /**
         * Handle any "keydown" event received by the component
         * @param {SyntheticEvent} event
         */
        _this.handleKeyDown = function (event) {
            _this.handleInteractionStart(event);
        };
        /**
         * Handle any "keyup" event received by the component
         * @param {SyntheticEvent} event
         */
        _this.handleKeyUp = function (event) {
            _this.handleInteractionEnd(event);
        };
        /**
         * Handle any "mousedown" event received by the component
         * @param {SyntheticEvent} event
         */
        _this.handleMouseDown = function (event) {
            _this.handleInteractionStart(event);
            _this.addDocumentMouseUpListener();
        };
        /**
         * Handle any "mouseup" event received by the component
         * @param {SyntheticEvent} event
         */
        _this.handleMouseUp = function (event) {
            _this.handleInteractionEnd(event);
            _this.removeDocumentMouseUpListener();
        };
        /**
         * Handle any "touchstart" event received by the component
         * @param {SyntheticEvent} event
         */
        _this.handleTouchStart = function (event) {
            _this.handleInteractionStart(event);
            _this.addDocumentTouchEndListener();
        };
        /**
         * Handle any "touchend" event received by the component
         * @param {SyntheticEvent} event
         */
        _this.handleTouchEnd = function (event) {
            _this.handleInteractionEnd(event);
            _this.removeDocumentTouchEndListener();
        };
        /**
         * Convert a point into a percentage value
         * @param {Point} position
         * @param {ClientRect} clientRect
         * @return {number} Percentage value
         */
        _this.getPercentageFromPosition = function (position, clientRect) {
            var clientRectLength = clientRect.width;
            var sizePerc = position.x / clientRectLength;
            return sizePerc || 0;
        };
        /**
         * Convert a point into a model value
         * @param {Point} position
         * @param {number} minValue
         * @param {number} maxValue
         * @param {ClientRect} clientRect
         * @return {number}
         */
        _this.getValueFromPosition = function (position, minValue, maxValue, clientRect) {
            var sizePerc = _this.getPercentageFromPosition(position, clientRect);
            var valueDiff = maxValue - minValue;
            return minValue + valueDiff * sizePerc;
        };
        _this.getValue = function () {
            var valueProps = _this.props.value;
            var valueState = _this.state.value;

            return (0, _utils.isDefined)(valueProps) && !(0, _utils.isDefined)(valueState) ? valueProps : valueState;
        };
        /**
         * Convert props into a range value
         * @param {Object} props
         * @param {boolean} isMultiValue
         * @return {Range}
         */
        _this.getValueFromProps = function (props, isMultiValue) {
            if (isMultiValue) {
                return Object.assign({}, _this.getValue());
            }
            return {
                min: props.minValue,
                max: _this.getValue()
            };
        };
        /**
         * Convert a model value into a percentage value
         * @param {number} value
         * @param {number} minValue
         * @param {number} maxValue
         * @return {number}
         */
        _this.getPercentageFromValue = function (value, minValue, maxValue) {
            var validValue = (0, _utils.clamp)(value, minValue, maxValue);
            var valueDiff = maxValue - minValue;
            var valuePerc = (validValue - minValue) / valueDiff;
            return valuePerc || 0;
        };
        /**
         * Convert model values into percentage values
         * @param {Range} values
         * @param {number} minValue
         * @param {number} maxValue
         * @return {Range}
         */
        _this.getPercentagesFromValues = function (values, minValue, maxValue) {
            return {
                min: _this.getPercentageFromValue(values.min, minValue, maxValue),
                max: _this.getPercentageFromValue(values.max, minValue, maxValue)
            };
        };
        /**
         * Convert a value into a point
         * @param {number} value
         * @param {number} minValue
         * @param {number} maxValue
         * @param {ClientRect} clientRect
         * @return {Point} Position
         */
        _this.getPositionFromValue = function (value, minValue, maxValue, clientRect) {
            var lengthValue = clientRect.width;
            var valuePerc = _this.getPercentageFromValue(value, minValue, maxValue);
            var positionValue = valuePerc * lengthValue;
            return {
                x: positionValue,
                y: 0
            };
        };
        /**
         * Convert a range of values into points
         * @param {Range} values
         * @param {number} minValue
         * @param {number} maxValue
         * @param {ClientRect} clientRect
         * @return {Range}
         */
        _this.getPositionsFromValues = function (values, minValue, maxValue, clientRect) {
            return {
                min: _this.getPositionFromValue(values.min, minValue, maxValue, clientRect),
                max: _this.getPositionFromValue(values.max, minValue, maxValue, clientRect)
            };
        };
        /**
         * Convert an event into a point
         * @param {Event} event
         * @param {ClientRect} clientRect
         * @return {Point}
         */
        _this.getPositionFromEvent = function (event, clientRect) {
            var lengthOfClientRec = clientRect.width;

            var _ref = event.touches ? event.touches[0] : event,
                clientX = _ref.clientX;

            return {
                x: (0, _utils.clamp)(clientX - clientRect.left, 0, lengthOfClientRec),
                y: 0
            };
        };
        /**
         * Convert a value into a step value
         * @param {number} value
         * @param {number} valuePerStep
         * @return {number}
         */
        _this.getStepValueFromValue = function (value, valuePerStep) {
            return Math.round(value / valuePerStep) * valuePerStep;
        };
        /**
         * Return JSX of thumbs
         * @return {JSX.Element}
         */
        _this.renderThumbs = function () {
            var _this$state5 = _this.state,
                minValue = _this$state5.minValue,
                maxValue = _this$state5.maxValue;
            var _this$props4 = _this.props,
                ariaLabelledby = _this$props4.ariaLabelledby,
                ariaControls = _this$props4.ariaControls,
                className = _this$props4.className;

            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var percentages = _this.getPercentagesFromValues(values, minValue, maxValue);
            return _this.getKeys().map(function (key) {
                var value = values[key];
                var percentage = percentages[key];
                var maxValueFromProps = _this.props.maxValue;
                var minValueFromProps = _this.props.minValue;

                if (key === 'min') {
                    maxValueFromProps = values.max;
                } else {
                    minValueFromProps = values.min;
                }
                var thumb = _react2.default.createElement(_Thumb2.default, { ariaLabelledby: ariaLabelledby || _this.labelId, ariaControls: ariaControls, className: className, key: key, maxValue: maxValueFromProps, minValue: minValueFromProps, onThumbDrag: _this.handleThumbDrag, onThumbKeyDown: _this.handleThumbKeyDown, percentage: percentage, type: key, value: value, onDragStart: _this.startDrag, onDragEnd: _this.endDrag });
                return thumb;
            });
        };
        _this.assignNode = function (node) {
            _this.formNode = node && node.form;
        };
        _this.renderLabelValues = function () {
            var _this$props5 = _this.props,
                className = _this$props5.className,
                name = _this$props5.name,
                labelPostfix = _this$props5.labelPostfix,
                labelPrefix = _this$props5.labelPrefix,
                labelClassName = _this$props5.labelClassName,
                labelValueClassName = _this$props5.labelValueClassName,
                labelValueFunction = _this$props5.labelValueFunction,
                customValues = _this$props5.customValues,
                minValueLabelTemplate = _this$props5.minValueLabelTemplate,
                currentValueLabelTemplate = _this$props5.currentValueLabelTemplate,
                maxValueLabelTemplate = _this$props5.maxValueLabelTemplate,
                customLabelFunction = _this$props5.customLabelFunction;
            var _this$state6 = _this.state,
                minValue = _this$state6.minValue,
                maxValue = _this$state6.maxValue;

            return _react2.default.createElement(_Label4.default, { className: className, value: _this.getValue(), minValue: minValue, maxValue: maxValue, name: name, postfix: labelPostfix, prefix: labelPrefix, labelClassName: labelClassName, labelValueClassName: labelValueClassName, displayCustomValue: customValues ? _this.displayCustomValue : undefined, labelValueFunction: labelValueFunction, minValueLabelTemplate: minValueLabelTemplate, currentValueLabelTemplate: currentValueLabelTemplate, maxValueLabelTemplate: maxValueLabelTemplate, customLabelFunction: customLabelFunction });
        };
        _this.render = function () {
            var _this$state7 = _this.state,
                minValue = _this$state7.minValue,
                maxValue = _this$state7.maxValue;
            var _this$props6 = _this.props,
                fieldWidth = _this$props6.fieldWidth,
                renderLabel = _this$props6.renderLabel,
                label = _this$props6.label,
                disabled = _this$props6.disabled,
                className = _this$props6.className;

            var componentClassName = _this.getComponentClassName();
            var values = _this.getValueFromProps(_this.props, _this.isMultiValue());
            var percentages = _this.getPercentagesFromValues(values, minValue, maxValue);
            return _react2.default.createElement(_Field2.default, { width: fieldWidth }, renderLabel && _react2.default.createElement(_Label2.default, { id: _this.labelId }, _react2.default.createElement("strong", null, label), _this.renderLabelValues()), _react2.default.createElement("div", { "aria-disabled": disabled, ref: function ref(node) {
                    _this.node = node;
                }, className: componentClassName, onKeyDown: _this.handleKeyDown, onKeyUp: _this.handleKeyUp, onMouseDown: _this.handleMouseDown, onTouchStart: _this.handleTouchStart, role: "button" }, _react2.default.createElement("div", { className: className.sliderContainer }, _react2.default.createElement(_Track2.default, { className: className, ref: function ref(trackNode) {
                    _this.trackNode = trackNode;
                }, percentages: percentages, onTrackMouseDown: _this.handleTrackMouseDown }, _this.renderThumbs()), _this.renderHiddenInputs())));
        };
        return _this;
    }

    _createClass(Slider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.formNode) {
                this.formNode.addEventListener('reset', this.reset, false);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeDocumentMouseUpListener();
            this.removeDocumentTouchEndListener();
            if (this.formNode) {
                this.formNode.removeEventListener('reset', this.reset);
            }
        }
        /**
         * Return the CSS class name of the component
         * @return {string}
         */

    }, {
        key: 'getComponentClassName',
        value: function getComponentClassName() {
            var _props = this.props,
                disabled = _props.disabled,
                className = _props.className;

            if (!disabled) {
                return className.slider;
            }
            return className.disabledSlider;
        }
        /**
         * Return the bounding rect of the track
         * @return {ClientRect}
         */

    }, {
        key: 'getTrackClientRect',
        value: function getTrackClientRect() {
            return this.trackNode.getClientRect();
        }
    }, {
        key: 'getCustomValue',
        value: function getCustomValue(value) {
            var customValues = this.props.customValues;

            return (0, _utils.isObject)(value) ? {
                min: customValues[value.min],
                max: customValues[value.max]
            } : customValues[value];
        }
    }, {
        key: 'getValueFromCustomValues',
        value: function getValueFromCustomValues(value) {
            var customValues = this.props.customValues;

            return (0, _utils.isObject)(value) ? {
                min: customValues.indexOf(value.min),
                max: customValues.indexOf(value.max)
            } : customValues.indexOf(value);
        }
    }, {
        key: 'getCustomValueDefaults',
        value: function getCustomValueDefaults() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var defaultValue = props.defaultValue;

            return this.getValueFromCustomValues(defaultValue);
        }
        /**
         * Return JSX of hidden inputs
         * @return {JSX.Element}
         */

    }, {
        key: 'renderHiddenInputs',
        value: function renderHiddenInputs() {
            var _this2 = this;

            var _props2 = this.props,
                name = _props2.name,
                valueDecoratorFn = _props2.valueDecoratorFn;

            if (!name) {
                return [];
            }
            var isMultiValue = this.isMultiValue();
            var values = this.getValueFromProps(this.props, isMultiValue);
            return this.getKeys().map(function (key) {
                var value = valueDecoratorFn ? valueDecoratorFn({ value: values[key], feature: key }) : values[key];
                var inputName = isMultiValue ? '' + name + (0, _utils.capitalize)(key) : name;
                return _react2.default.createElement("input", { ref: _this2.assignNode, key: key, type: "hidden", name: inputName, value: value });
            });
        }
    }]);

    return Slider;
}(_react2.default.Component);

exports.default = Slider;

Slider.propTypes = {
    ariaLabelledby: _propTypes2.default.string.isRequired,
    ariaControls: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.objectOf(_propTypes2.default.string),
    label: _propTypes2.default.node.isRequired,
    labelClassName: _propTypes2.default.string.isRequired,
    labelValueClassName: _propTypes2.default.string.isRequired,
    labelValueFunction: _propTypes2.default.func.isRequired,
    customLabelFunction: _propTypes2.default.func.isRequired,
    labelPostfix: _propTypes2.default.string.isRequired,
    labelPrefix: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool,
    maxValue: _propTypes2.default.number,
    minValue: _propTypes2.default.number,
    name: _propTypes2.default.string.isRequired,
    onChangeStart: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onChangeComplete: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), _propTypes2.default.shape({
        min: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        max: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
    })]).isRequired,
    renderLabel: _propTypes2.default.bool,
    customValues: _propTypes2.default.arrayOf(_propTypes2.default.any).isRequired,
    id: _propTypes2.default.string,
    valueDecoratorFn: _propTypes2.default.func,
    minValueLabelTemplate: _propTypes2.default.string.isRequired,
    currentValueLabelTemplate: _propTypes2.default.string.isRequired,
    maxValueLabelTemplate: _propTypes2.default.string.isRequired,
    fieldWidth: _propTypes2.default.string.isRequired
};
Slider.defaultProps = {
    renderLabel: true,
    className: {
        activeTrack: 'luna-slider__track luna-slider__track--fill',
        disabledSlider: 'luna-slider is-disabled',
        slider: 'luna-slider',
        sliderContainer: 'luna-slider__container',
        label: 'luna-label',
        thumb: 'luna-slider__thumb',
        thumbContainer: 'luna-slider__thumb-container',
        track: 'luna-slider__track'
    },
    disabled: false,
    maxValue: 10,
    minValue: 0,
    id: ''
};
//# sourceMappingURL=Slider.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Slider/Slider.js